<template>
    <div class="kt-portlet__head">
        <form class="isprint-filter" autocomplete="off"> 
            <div class="form-group">
                <label>APPEZZAMENTO</label>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Appezzamento" type="text" style="width:200px" v-model="search.ID_APPEZZAMENTO.VALUE">
            </div>
            <div class="form-group">
                <label>FOGLIO</label>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Foglio" type="text" style="width:200px" v-model="search.FOGLIO.VALUE">
            </div>
            <div class="form-group ">
                <label>PARTICELLA</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Particella" type="text" style="width:200px" v-model="search.PARTICELLA.VALUE">
            </div>
            <div class="form-group ">
                <label>LOCALITA</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Località" type="text" style="width:200px" v-model="search.LOCALITA.VALUE">
            </div>
            <div class="form-group ">
                <label>COGNOME ASSEGNATARIO</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Cognome" type="text" style="width:200px" v-model="search.COGNOME.VALUE">
            </div>
            <div class="form-group ">
                <label>NOME ASSEGNATARIO</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Nome" type="text" style="width:200px" v-model="search.NOME.VALUE">
            </div>
            <button class="btn btn-success float-right my-2 my-sm-3 mt-4 btn-sm" v-on:click="creaTerreno()"><i class="fas fa-plus"></i> Nuovo Terreno</button>
        </form> 
    </div>
    <div class="isprint-grid-container"  >    
        <table class="isprint-grid shadow" >
            <thead class="isprint-grid-thead" >
                <tr style="left: 0px;background: #258c08;color:#fff">
                    <th  style="width:10%"><span >ID APPEZZAMENTO</span></th>
                    <th  style="width:5%"><span >FOGLIO</span></th>
                    <th  style="width:5%"><span >PARTICELLA</span></th>
                    <th  style="width:25%"><span >LOCALITA</span></th>
                    <th  style="width:25%"><span >ASSEGNATARIO</span></th>
                    <th  style="width:10%"><span >AZIONI</span></th>
                    
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-bind:key="terreno.ID_TERRENO"  v-for="terreno in paginatedList.arr">                        
                    <td  style="width:10%;font-size:16px">
                        {{ terreno.ID_APPEZZAMENTO }}
                    </td>
                    <td  style="width:5%">
                        {{ terreno.FOGLIO }}
                    </td>
                    <td  style="width:5%">
                        {{ terreno.PARTICELLA }}
                    </td>         
                    <td  style="width:25%">
                        {{ terreno.LOCALITA }}
                    </td>
                    <td  style="width:25%">
                        {{ terreno.COGNOME }} {{ terreno.NOME }}
                        <br>
                        <small>{{ terreno.DATA_NASCITA }} - {{ terreno.CODICE_FISCALE }}</small>
                    </td>
                    <td  style="width:10%">
                        <div class="btn-group float-right" role="group" aria-label="Basic example">
                            <button data-toggle="tooltip" data-placement="top" title="Modifica terreno" class="btn btn-warning btn-sm float-right" v-on:click="modificaTerreno(terreno.ID_TERRENO)"><i class="fal fa-pencil"></i></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER"  :numrighe="paginatedList.count"  :numpagine="search.PAGINATION.LENGTH"></Pagine> 
    </div>
    <div class="modal fade" id="popUpTerreno" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:1000px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header" style="background-color: #226636;">
                    <h4 style="color:#fff" class="modal-title">{{ terrenoSelezionato.LOCALITA }}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" >
                    <Terreno  v-model="terrenoSelezionato" @ricarica="modificaTerreno($event)" @getTerreno=" getTerreno" ref="terreno"></Terreno>       
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaTerreno()"><i class="fa fa-check"></i> Salva</button>
                </div>
            </div>  
        </div>
    </div>

</template>
<script>


import Pagine from '@/components/utils/Pagine.vue'
import Terreno from '@/components/Terreno.vue'



export default {
    name:"Terreni",
    components:{
        Pagine,
        Terreno
    },
    data:function(){
        return{
            filters:global.filters,
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:50},
                ID_APPEZZAMENTO:{TYPE:'TEXT',VALUE:''}, 
                FOGLIO:{TYPE:'TEXT',VALUE:''}, 
                PARTICELLA:{TYPE:'TEXT',VALUE:''}, 
                LOCALITA:{TYPE:'TEXT',VALUE:''},
                COGNOME:{TYPE:'TEXT',VALUE:''},
                NOME:{TYPE:'TEXT',VALUE:''},
                               
            },        
        
            arrayTerreni:new Array(),
            anni:new Array(),
            terrenoSelezionato: {},
        
        }
    },
    methods: {
        getTerreni : function(){
            global.utils.get('/emmet/terreni',{}, (response) => {       
                this.arrayTerreni = response.data;
            });
        },
        getTerreno: function(idTerreno){
            global.utils.get('emmet/terreno',{ID_TERRENO: idTerreno},(response)=>{
                this.terrenoSelezionato = utils.clone(response.data);
                this.terrenoSelezionato.isAssegnato = false;
                if (response.data.assegnazioni != undefined){
                    response.data.assegnazioni.forEach(assegnazione => {
                        if (assegnazione.VALIDO == 1){
                            this.terrenoSelezionato.isAssegnato = true;
                        }
                    });
                }
            });
        },  
        modificaTerreno: function(idTerreno){
            var modal = utils.openModal('popUpTerreno');
            this.getTerreno(idTerreno);
        },
        salvaTerreno : function(){
            this.terrenoSelezionato.FK_ID_TIPO = 1;
        //    console.log(this.terrenoSelezionato);
            //update
            if(this.terrenoSelezionato.ID_TERRENO > 0){
                global.utils.put('/emmet/terreno',this.terrenoSelezionato, (response) => {
                    if (response.esito == 0){
                        this.getTerreni();
                        var modal = utils.closeModal('popUpTerreno')
                        utils.alert.success(response.messaggio);
                    }
                });
            }else{
                global.utils.post('/emmet/terreno',this.terrenoSelezionato,(response)=>{
                    if (response.esito == 0){
                        this.getTerreni()
                        var modal = utils.closeModal('popUpTerreno')
                        utils.alert.success(response.messaggio);
                    }
                });
            }
        },
        creaTerreno : function(){
            this.terrenoSelezionato = {ID_TERRENO:0}
            var modal = utils.openModal('popUpTerreno'); 
        },
        
    },
    computed : {
        paginatedList(){
            var arr = utils.inGrid(this.arrayTerreni,this.search);
            return arr;
        }, 
    },
    created : function(){
       this.getTerreni(); 
    },

}


</script>
